import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const NametenantSlice =  createSlice({
    name:"Tenant",
    initialState:{
        name:""
    },
    reducers:{
        SetNameTenant(state, action: PayloadAction<string>){
            state.name = action.payload
        }
    }
});

export const { SetNameTenant } = NametenantSlice.actions
export default NametenantSlice.reducer